export const scrollToElement = (reference, options = {}) => {
  if (reference.current)
    reference.current.scrollIntoView({ behavior: 'smooth', ...options });
  else return null;
};
